import { render } from "./DatasourceDeletePage.vue?vue&type=template&id=fa3b9a28"
import script from "./DatasourceDeletePage.vue?vue&type=script&lang=js"
export * from "./DatasourceDeletePage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__